import { render } from "./CustomFormButton.vue?vue&type=template&id=46f9a616"
import script from "./CustomFormButton.vue?vue&type=script&lang=js"
export * from "./CustomFormButton.vue?vue&type=script&lang=js"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__